<form #locationSearchForm="ngForm" (submit)="performSearch()">
  <mat-form-field appearance="outline">
    <input
      matInput
      type="text"
      (blur)="onBlur()"
      (focus)="onFocus()"
      [disabled]="disabled"
      class="form-control"
      name="locationSearch"
      id="locationSearch"
      #locationSearchInput
      [placeholder]="placeholder"
      [(ngModel)]="searchQuery"
      autocomplete="off"
      (keyup)="onKeyUp($event)"
    />
  </mat-form-field>
  <div *ngIf="displayFavoriteLocationIcon">
    <button mat-icon-button type="button" (click)="favoriteLocationSelectionClicked()"><mat-icon>star_rate</mat-icon>></button>
  </div>
  <button mat-icon-button type="submit" [disabled]="!locationSearchForm.form.valid"><mat-icon>search</mat-icon></button>
  <div class="location_search_autocomplete_container" *ngIf="searchResults">
    <mat-list>
      <mat-list-item class="autocomplete-item" *ngFor="let searchResult of searchResults" (mousedown)="selectSearchResult(searchResult)">
        <span class="autocomplete-item-text">{{ searchResult.label }}</span>
        <mat-divider></mat-divider>
      </mat-list-item>
    </mat-list>
  </div>
</form>
